import React from "react";
import AccountTickets from "./AccountTickets";
import AccountReservation from "./AccountReservation";

interface IProps {
  ticketsTabActive: number;
}

const AccountDocPanel: React.FC<IProps> = ({ ticketsTabActive }: IProps) => {
  return (
    <div className={"panel-account-docs"}>
      {ticketsTabActive === 0 && <AccountTickets />}
      {ticketsTabActive === 1 && <AccountReservation />}
    </div>
  );
};

export default AccountDocPanel;
